import { apm } from '@elastic/apm-rum';

const offlineError = (error: Error) => {
  apm.captureError(error, {
    labels: {
      offline: true,
    },
  });
};

const clarityError = (error: Error) => {
  apm.captureError(error, {
    labels: {
      clarity: true,
    },
  });
};

const infiniteLoadingError = (error: Error) => {
  apm.captureError(error, {
    labels: {
      infiniteLoading: true,
    },
  });
};

const snackbarUnexpectedMessageError = (error: Error) => {
  apm.captureError(error, {
    labels: {
      snackbarUnexpectedMessage: true,
    },
  });
};

const unresolvedActivityFeedRowError = (error: Error) => {
  apm.captureError(error, {
    labels: {
      unresolvedActivityFeedRow: true,
    },
  });
};

const snackbarUntranslatedValidationError = (error: Error) => {
  apm.captureError(error, {
    labels: {
      snackbarUntranslatedValidation: true,
    },
  });
};

export const captureErrorInApm = {
  offlineError,
  clarityError,
  infiniteLoadingError,
  snackbarUnexpectedMessageError,
  unresolvedActivityFeedRowError,
  snackbarUntranslatedValidationError,
};
